import { useCopyToClipboard } from '@/hooks';
import { getFlaskAdminDrugTestReportUrl } from '../utils';
import { COPY_SUCCESS, QUICK_ACTION_LABELS } from './constants';
import { ActionLink, ActionLinks } from './styled';
import type { QuickActionsProps } from './types';

const openExternal = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

const QuickActions = ({ report }: QuickActionsProps) => {
  const { copyToClipboard } = useCopyToClipboard();

  if (!report) return null;

  const schedulingUrl = report.scheduling_url;
  const donorPassUrl = report.donor_pass_url;
  const finalReportUrl = report.final_report_url;
  const flaskAdminUrl = getFlaskAdminDrugTestReportUrl(report.id);

  return (
    <ActionLinks>
      <ActionLink
        type="button"
        onClick={() =>
          copyToClipboard({
            textToCopy: report.id,
            notifyProps: { onSuccess: { message: COPY_SUCCESS.reportId } },
          })
        }
      >
        {QUICK_ACTION_LABELS.copyReportId}
      </ActionLink>

      <ActionLink
        type="button"
        disabled={!schedulingUrl}
        onClick={() => {
          if (!schedulingUrl) return;
          copyToClipboard({
            textToCopy: schedulingUrl,
            notifyProps: { onSuccess: { message: COPY_SUCCESS.schedulingUrl } },
          });
        }}
      >
        {QUICK_ACTION_LABELS.copySchedulingUrl}
      </ActionLink>

      <ActionLink
        type="button"
        disabled={!donorPassUrl}
        onClick={() => {
          if (!donorPassUrl) return;
          openExternal(donorPassUrl);
        }}
      >
        {QUICK_ACTION_LABELS.openDonorPass}
      </ActionLink>

      <ActionLink
        type="button"
        disabled={!finalReportUrl}
        onClick={() => {
          if (!finalReportUrl) return;
          openExternal(finalReportUrl);
        }}
      >
        {QUICK_ACTION_LABELS.openFinalReport}
      </ActionLink>

      <ActionLink type="button" onClick={() => openExternal(flaskAdminUrl)}>
        {QUICK_ACTION_LABELS.flaskAdmin}
      </ActionLink>
    </ActionLinks>
  );
};

export default QuickActions;
